import React, { useEffect } from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { BUSINESS } from "@/data/content";

export default function Contact() {
  useEffect(() => { document.title = "Contact · Washington Family Provisions"; }, []);
  return (
    <div className="mx-auto max-w-4xl px-5 py-20 md:px-8">
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-honey-dark">We'd love to hear from you</p>
      <h1 className="mt-3 font-serif text-5xl text-wood-900 md:text-6xl">Contact us</h1>
      <p className="mt-4 max-w-xl text-wood-700">
        Questions about an order, a gift, or one of our products? Reach out and a member of our family will get back to you.
      </p>
      <div className="mt-12 grid gap-6 sm:grid-cols-3">
        <a href={`mailto:${BUSINESS.email}`} className="rounded-3xl bg-sand p-7 transition-shadow hover:shadow-lg" data-testid="contact-email">
          <Mail className="text-honey-dark" />
          <h2 className="mt-4 font-serif text-xl text-wood-900">Email</h2>
          <p className="mt-1 break-words text-sm text-wood-700">{BUSINESS.email}</p>
        </a>
        <a href={`tel:${BUSINESS.phone}`} className="rounded-3xl bg-sand p-7 transition-shadow hover:shadow-lg" data-testid="contact-phone">
          <Phone className="text-honey-dark" />
          <h2 className="mt-4 font-serif text-xl text-wood-900">Phone</h2>
          <p className="mt-1 text-sm text-wood-700">{BUSINESS.phone}</p>
        </a>
        <div className="rounded-3xl bg-sand p-7">
          <MapPin className="text-honey-dark" />
          <h2 className="mt-4 font-serif text-xl text-wood-900">Based in</h2>
          <p className="mt-1 text-sm text-wood-700">{BUSINESS.address}</p>
        </div>
      </div>
    </div>
  );
}
